import React from 'react';
import LightMarkers from "./LightMarkers";
import FoodMarkers from "./FoodMarkers";
import RentMarkers from "./RentMarkers";
import SkischoolMarkers from "./SkiSchoolMarkers";
import ParkingMarkers from "./ParkingMarkers";
import MedicalMarkers from "./MedicalMarkers";
import BorjomiMarkers from "./BorjomiMarkers";
import SleighMarkers from "./SleighMarkers";
import VodaMarkers from "./VodaMarkers";
import SkatingMarkers from "./SkatingMarkers";
import { AppContext } from "../../App";

const MapMarkers = () => (
	<AppContext.Consumer>
		{({ markersVisibility }) => (
			<>
				<LightMarkers/>
				{markersVisibility.showFoodMarkers && <FoodMarkers/>}
				{markersVisibility.showRentMarkers && <RentMarkers/>}
				{markersVisibility.showSkiMarkers && <SkischoolMarkers/>}
				<ParkingMarkers/>
				{markersVisibility.showMedicalMarkers && <MedicalMarkers/>}
				<BorjomiMarkers/>
				<SleighMarkers/>
				<VodaMarkers/>
				{markersVisibility.showSkatingMarkers && <SkatingMarkers/>}
			</>
		)}
	</AppContext.Consumer>
);

export default MapMarkers;
